const testimonialsData = [
  {
    id: 1,
    name: 'Rajesh Khanna',
    location: 'Gurugram',
    rating: 5,
    review: 'Astro Interiors transformed our 3BHK in Gurgaon into a modern masterpiece. Their attention to detail and understanding of Vastu principles is commendable. The team was professional and delivered before time!',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    project: '3BHK Interior Design',
    date: 'June 2023'
  },
  {
    id: 2,
    name: 'Priya Singh',
    location: 'Noida',
    rating: 5,
    review: 'The team at Astro Interiors made our dream home a reality. Their innovative designs and quality materials have exceeded our expectations. Special thanks to the designers for their patience and creativity.',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    project: 'Complete Home Makeover',
    date: 'April 2023'
  },
  {
    id: 3,
    name: 'Amit & Neha Sharma',
    location: 'Delhi',
    rating: 5,
    review: 'From the first meeting to the final handover, the experience was seamless. They understood our requirements perfectly and delivered beyond our imagination. Our friends keep asking who designed our home!',
    image: 'https://randomuser.me/api/portraits/men/45.jpg',
    project: 'Luxury Penthouse Interior',
    date: 'February 2023'
  },
  {
    id: 4,
    name: 'Sanjay Verma',
    location: 'Faridabad',
    rating: 4,
    review: 'Great experience working with Astro Interiors. They provided excellent design solutions within our budget. The project was completed on time with minimal supervision required from our side.',
    image: 'https://randomuser.me/api/portraits/men/68.jpg',
    project: 'Office Space Design',
    date: 'January 2023'
  },
  {
    id: 5,
    name: 'Meena Kapoor',
    location: 'Ghaziabad',
    rating: 5,
    review: 'The team transformed our outdated house into a modern, functional home. Their 3D visualization helped us make decisions easily. The quality of work is top-notch and worth every penny.',
    image: 'https://randomuser.me/api/portraits/women/63.jpg',
    project: 'Complete Home Renovation',
    date: 'December 2022'
  },
  {
    id: 6,
    name: 'Vikram Mehta',
    location: 'Delhi NCR',
    rating: 5,
    review: 'Professional, creative, and reliable. Astro Interiors delivered exactly what we envisioned. Their post-completion support has been excellent. Highly recommended for anyone looking for quality interior work.',
    image: 'https://randomuser.me/api/portraits/men/22.jpg',
    project: 'Villa Interior Design',
    date: 'November 2022'
  }
];

export default testimonialsData;
